import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const orderslice = createSlice({
    name: "orderslice",
    initialState: {

        order_modal: false,
        orderSelectedproducts: [],
        orderdatabyid: [],
        orderNextstep:false,
        assigndriverdata:[],
        updateddata:[],
        orderamount:{},
        ordershippingcharges:0,
        orderbalanceamount:0,
        orderdiscountcharges:0,
        orderdonationfee:0,
        processing_fee:0,
        chargesfee:0,
        vieworderbyid:"",
        selectedRows:[],
        orderAddress:{},
        selectedRows:[],
        creditedamount:'',
        ordercustomeraddress:[],
        selectmultipleproductid:[],
        vendorOrderSelected:[],
        cleardataafterassign:false,
        ordersearchselectproduct:{},
        orderselectedvendorproducts:[],
        purchaseitems:[],
        purchasereming:{
            total:"",
            subtoatal:'',
            vat:'',
            notes:'',
            roundof:'',
            discount:'',
        },
             customeraddress: [],
        customerbillingaddress: {},
        customershippingaddress: {}

    },
    reducers: {
        setorderdatabyid: (state, action) => {
            state.orderdatabyid = action.payload; // for in orderpage selected products 
        },
        setorderNextstep: (state, action) => {
            state.orderNextstep = action.payload; 
        },
        setSelectedRows: (state, action) => {
            state.selectedRows = action.payload; 
        },
        setassigndriverdata: (state, action) => {
            state.assigndriverdata = action.payload; 
        },
        setupdateddata: (state, action) => {
            state.updateddata = action.payload; 
        },
        setorderamount: (state, action) => {
            state.orderamount = action.payload; 
        },
        setcleardataafterassign: (state, action) => {
            state.cleardataafterassign = action.payload; 
        },
        setordershippingcharges: (state, action) => {
            state.ordershippingcharges = action.payload; 
        },
        setorderbalanceamount: (state, action) => {
            state.orderbalanceamount = action.payload; 
        },
        setprocessing_fee: (state, action) => {
            state.processing_fee = action.payload; 
        },
        setchargesfee: (state, action) => {
            state.chargesfee = action.payload; 
        },
        setorderdiscountcharges: (state, action) => {
            state.orderdiscountcharges = action.payload; 
        },
        setorderdonationfee: (state, action) => {
            state.orderdonationfee = action.payload; 
        },
        setvieworderbyid: (state, action) => {
            state.vieworderbyid = action.payload; 
        },
        setorderAddress: (state, action) => {
            state.orderAddress = action.payload; 
        },
        setselectmultipleproductid: (state, action) => {
            state.selectmultipleproductid = action.payload; 
        },
        setvendorOrderSelected: (state, action) => {
            state.vendorOrderSelected = action.payload; 
        },
        setordercustomeraddress: (state, action) => {
            state.ordercustomeraddress = action.payload; 
        },
        setSelectedRows: (state, action) => {
            state.selectedRows = action.payload; 
        },
        setordersearchselectproduct: (state, action) => {
            state.ordersearchselectproduct = action.payload; 
        },
        setorderselectedvendorproducts: (state, action) => {
            state.orderselectedvendorproducts = action.payload; 
        },
        setcreditedamount: (state, action) => {
            state.creditedamount = action.payload; 
        },
        setpurchaseitems: (state, action) => {
            state.purchaseitems = action.payload; 
        },
        setpurchasereming: (state, action) => {
            state.purchasereming = action.payload; 
        },
             setcustomeraddress: (state, action) => {
            state.customeraddress = action.payload;
        },
        setcustomerbillingaddress: (state, action) => {
            state.customerbillingaddress = action.payload;
        },
        setcustomershippingaddress: (state, action) => {
            state.customershippingaddress = action.payload;
        },
    }
});
export const {setSelectedRows,setcustomeraddress,setcustomerbillingaddress,setcustomershippingaddress,setorderdatabyid,setorderNextstep,setvendorOrderSelected,setchargesfee,setpurchasereming,setassigndriverdata,setpurchaseitems,setorderdonationfee, setorderdiscountcharges,setprocessing_fee,setorderAddress ,setupdateddata,setorderamount,setorderbalanceamount,setordershippingcharges,setvieworderbyid,setselectmultipleproductid,setordercustomeraddress,setordersearchselectproduct,setorderselectedvendorproducts,setcreditedamount} = orderslice.actions
export default orderslice.reducer;
